import { PackageCategory } from '../enums/package-category.enum';
import { SelfCheckoutPackageMetaResponseDto } from '../types/response';
import { BillingFrequency, PackageDisplayConfigLocal, PACKAGES_DISPLAY_CONFIG } from './packages-display.config';

export interface PackageDisplayConfigAdditionalData {
  price: string;
  packagePrice: number;
  id: string;
  packageName: string;
  shortName: string;
  capacity: number;
  minimumContractDurationMonths: number;
  additionalConditions: string;
  slotString?: string;
  slotStringHighlight?: string;
}
export interface PackageDisplayConfig extends PackageDisplayConfigLocal {
  [BillingFrequency.MONTHLY]: PackageDisplayConfigAdditionalData;
  [BillingFrequency.QUARTERLY]: PackageDisplayConfigAdditionalData;
  [BillingFrequency.HALFYEARLY]: PackageDisplayConfigAdditionalData;
  //[BillingFrequency.YEARLY]: PackageDisplayConfigAdditionalData;
}

const toAdditionalData = (pkg: SelfCheckoutPackageMetaResponseDto): PackageDisplayConfigAdditionalData => ({
  capacity: pkg.capacity,
  minimumContractDurationMonths: pkg.minimumContractDurationMonths,
  price: pkg.packagePriceMonthlyString,
  packagePrice: pkg.packagePrice,
  id: pkg.id,
  packageName: pkg.packageName,
  shortName: pkg.shortName,
  additionalConditions: pkg.additionalConditions,
  slotString: pkg.slotString,
  slotStringHighlight: pkg.slotStringHighlight
});

export const mapBackendPackagesToDisplayConfig = (
  backendPackages: SelfCheckoutPackageMetaResponseDto[]
): Record<PackageCategory, PackageDisplayConfig> => {
  const result: Record<PackageCategory, PackageDisplayConfig> = {} as Record<PackageCategory, PackageDisplayConfig>;

  const packagesByCategory: Record<PackageCategory, SelfCheckoutPackageMetaResponseDto[]> = {
    [PackageCategory.LITE]: [],
    [PackageCategory.BASIC]: [],
    [PackageCategory.PRO]: [],
    [PackageCategory.ULTIMATE]: []
  };

  backendPackages.forEach((pkg) => {
    if (packagesByCategory[pkg.packageCategory]) {
      packagesByCategory[pkg.packageCategory].push(pkg);
    }
  });

  Object.values(PackageCategory).forEach((category) => {
    const displayConfigLocal = PACKAGES_DISPLAY_CONFIG[category];
    const categoryPackages = packagesByCategory[category];

    if (displayConfigLocal && categoryPackages.length > 0) {
      const additionalData: Record<BillingFrequency, PackageDisplayConfigAdditionalData> = {
        [BillingFrequency.MONTHLY]: {} as PackageDisplayConfigAdditionalData,
        [BillingFrequency.QUARTERLY]: {} as PackageDisplayConfigAdditionalData,
        [BillingFrequency.HALFYEARLY]: {} as PackageDisplayConfigAdditionalData
      };

      categoryPackages.forEach((pkg) => {
        if (pkg.minimumContractDurationMonths === 1) {
          additionalData[BillingFrequency.MONTHLY] = toAdditionalData(pkg);
        } else if (pkg.minimumContractDurationMonths === 3) {
          additionalData[BillingFrequency.QUARTERLY] = toAdditionalData(pkg);
        } else if (pkg.minimumContractDurationMonths === 6) {
          additionalData[BillingFrequency.HALFYEARLY] = toAdditionalData(pkg);
        }
      });

      result[category] = {
        ...displayConfigLocal,
        [BillingFrequency.MONTHLY]: additionalData[BillingFrequency.MONTHLY],
        [BillingFrequency.QUARTERLY]: additionalData[BillingFrequency.QUARTERLY],
        [BillingFrequency.HALFYEARLY]: additionalData[BillingFrequency.HALFYEARLY]
      };
    }
  });

  return result;
};
